import get from 'lodash/get';
import {useNavigate} from 'react-router-dom';

import AppDashboard from '../AppDashboard';
import PatientSettingsMenu from '../../components/patients/PatientSettingsMenu';

import {useGetCurrentUserQuery} from '../../redux/services/userApi';

const PatientSettingsPage = props => {
  const navigate = useNavigate();
  const patientQuery = useGetCurrentUserQuery();
  const childProps = {
    ...props,
    patient: get(patientQuery, 'data.data[0].patient'),
    patientId: get(patientQuery, 'data.data[0].patient.id'),
  };
  return (
    <AppDashboard title='Settings' hideBack={true} onBack={() => navigate('/clients')}>
      <PatientSettingsMenu {...childProps} />
    </AppDashboard>
  );
};

export default PatientSettingsPage;
